const API_URL = process.env.REACT_APP_API_URL || 'https://api.anapurnasales.com/api/v1';
const IMAGE_BASE_URL = API_URL.split('/api/v1')[0];


const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  }
  const result = await response.json();
  return Array.isArray(result) ? result : result.data || result;
};

export const api = {
  get: async (endpoint) => {
    const response = await fetch(`${API_URL}${endpoint}`);
    return handleResponse(response);
  },
  post: async (endpoint, data) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return handleResponse(response);
  },
  formatImageUrl: (url) => {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    const path = url.startsWith('/') ? url : `/${url}`;
    if (path.startsWith('/uploads')) return `${IMAGE_BASE_URL}${path}`;
    return `${IMAGE_BASE_URL}/uploads${path}`;
  }
};

export default api;
